var $alert = $('[data-object="alert"]');

$alert.on('alert.who_may_apply.US', function (event, opts) {
    $('.usajobs-search').find('#SelectedStatusUSLabel').trigger('click');
});

var $card_drawer = $('[data-object="card-drawer"]');

$card_drawer.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="card-drawer"]'),
      behavior = $el.attr('data-behavior'),
      $target = $object.find('#' + $object.attr('aria-controls')),
      state = $target.attr('aria-hidden');
      
    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^card-drawer/)) {
            $el.trigger(action, { el: $el, object: $object, target: $target, state: state });
        }
    });
});

$card_drawer.on('card-drawer.toggle', function (event, opts) {
    event.preventDefault();

    if (opts.state == "true") {
        opts.el.attr('aria-expanded', 'true');
        opts.target.attr('aria-hidden', 'false');

        opts.target.slideDown(function () {
            $('html, body').animate({
                scrollTop: opts.object.offset().top
            });
        });
    } else {
        opts.target.slideUp(function () {
            opts.el.attr('aria-expanded', 'false');
            opts.target.attr('aria-hidden', 'true');
        });
    }
});

// Used for the archive functionality
$card_drawer.on('card-drawer.remove', function (event, opts) {
    var $parent = opts.el.closest('[data-object="card-drawer"]');

    event.preventDefault();

    $parent.hide('slide', { direction: 'right' }, 300, function () {
        $parent.remove();
    });
});

// Saved jobs and searches
$(document).on("click", ".usajobs-home-saved-job__actions-save", function (event) {
    event.preventDefault();
});

$card_drawer.on('card-drawer.toggle-save', function (event, opts) {
    var saved_state = opts.el.attr('data-state');

    event.preventDefault();

    if (saved_state === "is-saved") {
        opts.el.text('Save');
        opts.el.attr('data-state', 'is-unsaved');
    } else {
        opts.el.text('Saved');
        opts.el.attr('data-state', 'is-saved');
    }
});

var $docs = $('[data-object="documents"]');

$docs.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="documents"]'),
      behavior = $el.attr('data-behavior'),
      $target = $object.find($el.attr('data-target'));

    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        $el.trigger(action, { el: $el, object: $object, target: $target });
    });
});

$docs.on('document.toggle_searchable', function (event, opts) {
    var $help_text = opts.object.find('.usajobs-document__searchable [data-help-text]'),
        target_id = opts.el.attr('id'),
        radio_buttons = document.querySelectorAll('input[type="radio"]');

    for (var i = 0; i < radio_buttons.length; i++) {
        if (radio_buttons[i].id != target_id) {
            $help_text.attr('aria-hidden', 'true');
            radio_buttons[i].checked = false;            
            opts.el.siblings('[data-help-text]').attr('aria-hidden', 'false');            
        }
        else {
            radio_buttons[i].checked = true;
            opts.el.siblings('[data-help-text]').attr('aria-hidden', 'false');
        }
    }
});

//Events
var $event_actions = $('[data-object="usajobs-event"]'),
  cleanUpShare = function ($list) {
      $list.children().show();
      $list.find('.link').show();
      $list.find('.short-url').remove();
  };

$event_actions.on('click', '[data-behavior]', function () {
    var $el = $(this),
      $object = $el.closest('[data-object="usajobs-event"]'),
      behavior = $el.attr('data-behavior');

    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^usajobs-event/)) {
            $el.trigger(action, { el: $el, object: $object });
        }
    });
});

$event_actions.on('usajobs-event.toggle-share', function (event, opts) {
    var target_id = opts.el.attr('id'),
      $target = opts.object.find('[aria-labeledby="' + target_id + '"]'),
      state = $target.attr('aria-hidden');

    if (state === 'true') {
        $target.attr('aria-hidden', false);
    } else {
        $target.attr('aria-hidden', true);
        cleanUpShare($target);
    }
});

$event_actions.on('usajobs-event.close-share', function (event, opts) {
    var target_id = opts.el.attr('data-target'),
      $target = opts.object.find(target_id),
      state = $target.attr('aria-hidden');

    if (state === 'true') {
        $target.attr('aria-hidden', false);
    } else {
        $target.attr('aria-hidden', true);
        cleanUpShare($target);
    }
});

$event_actions.on('usajobs-event.shorten-link', function (event, opts) {
    var base_url = 'https://go.usa.gov/api/shorten.jsonp',
      params = [
        { name: 'login', value: 'dev-usajobs' },
        { name: 'apiKey', value: '509326519e75e35f4355498bca0a31e2' }
      ],
      url_to_encode = opts.el.attr('data-shorten-url'),
      fixedEncodeURI = function (str) {
          // Reserves square brackets for IPv6 which follows RFC3986
          return encodeURI(str).replace(/%5B/g, '[').replace(/%5D/g, ']');
      },
      short_url;

    event.preventDefault();

    params.push({ name: 'longUrl', value: fixedEncodeURI(url_to_encode) });

    // This should be the list that holds the share elements
    // Not really disabled but it will appear so until the result comes back
    opts.el.parent().parent().addClass('is-disabled');

    $.ajax({
        url: base_url,
        dataType: 'jsonp',
        crossdomain: true,
        data: $.param(params),
        success: function (rsp) {
            short_url = rsp.response.data.entry[0].short_url;

            // Hide other sharing options to make space to show the short URL
            $.each(opts.el.parent().siblings(), function (idx, sibling) {
                $(sibling).hide();
            });
            opts.el.after('<span class="short-url">' + short_url + '</span>');
            opts.el.hide();
            opts.el.parent().parent().removeClass('is-disabled');
        }
    });
});

var $help = $('[data-object="help"]');

$help.on('change', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="help"]'),
      behavior = $el.attr('data-behavior'),
      $target = $object.find('#' + $el.attr('aria-controls'));

    event.preventDefault();
    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        $el.trigger(action, { el: $el, object: $object, target: $target });
    });
});

$help.on('help.open', function (event, opts) {
    event.preventDefault();

    opts.target.attr('aria-hidden', 'false');
});


var $home_accordion = $('[data-object="home-accordion"]');

$home_accordion.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="home-accordion"]'),
      behavior = $el.attr('data-behavior'),
      $target = $object.find('#' + $el.attr('aria-controls')),
      state = $target.attr('aria-hidden');

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^home/)) {
            $el.trigger(action, { el: $el, object: $object, target: $target, state: state });
        }
    });
});

$home_accordion.on('home-accordion.toggle', function (event, opts) {
    var viewport_width = $(document).innerWidth();

    event.preventDefault();

    if (opts.state == "true" && viewport_width < 768) {
        opts.target.slideDown(function () {
            $('html, body').animate({
                scrollTop: opts.object.offset().top
            });
        });
    } else {
        // Keep the accordion open as it has now converted to tabs
        //QQ: Customization - allow accordions to collapse all at mobile
        if (opts.state == "false" && viewport_width > 768) {
            window.setTimeout(function () {
                opts.el.attr('aria-expanded', 'true');
                opts.target.attr('aria-hidden', 'false');
            }, 1000);
        }
    }
});

$home_accordion.on('home-application-filter.toggle', function (event, opts) {
    event.preventDefault();

    if (opts.state == "true") {
        opts.el.attr('aria-expanded', 'true');
        opts.target.attr('aria-hidden', 'false');

        opts.target.slideDown(function () {
            $('html, body').animate({
                scrollTop: opts.object.offset().top
            });
        });
    } else {
        opts.target.slideUp(function () {
            opts.el.attr('aria-expanded', 'false');
            opts.target.attr('aria-hidden', 'true');
        });
    }
    setTimeout(() => { opts.el.focus() }, 100);
});

$home_accordion.on('home-application-filter.toggle_category', function (event, opts) {
    var $inputs = opts.target.find('input:checkbox'),
      target_state = opts.el.attr('aria-checked');

    if (target_state === 'true') {
        // uncheck checkboxes in group
        $inputs.prop('checked', false);
        opts.el.attr('aria-checked', false);
    } else {
        $inputs.prop('checked', true);
        opts.el.attr('aria-checked', true);
    }
    $inputs.trigger("change");
});

$home_accordion.on('home-application-filter.toggle_applications', function (event, opts) {
    var $all_filters = opts.object.find('[data-behavior="home-application-filter.toggle_applications"]'),
      $all_filters_active = opts.object.find('[data-behavior="home-application-filter.toggle_applications"]:checked'),
      $all_applications = opts.object.find('[data-application-states]');

    $all_applications.hide();

    // TODO: The data-application-states string has to be split
    // and then each state checked in order to handle applications with multiple states

    $.each($all_filters_active, function (index, filter) {
        var $filter = $(filter),
          state = $filter.prop('checked');

        if (state === true) {
            opts.object
              .find('[data-application-states="' + $filter.attr('name') + '"]')
              .show();
        } else {
            opts.object
              .find('[data-application-states="' + $filter.attr('name') + '"]')
              .hide();
        }
    });

    if ($all_filters_active.length === 0) {
        $all_applications.show();
    }

    // TODO: If selected filters show no results then inform the user
});

$home_accordion.on('home-application-notifications.trigger', function (event, opts) {
    event.preventDefault();

    if (opts.state == "true") {
        opts.target.attr('aria-hidden', 'false');
    } else {
        opts.target.attr('aria-hidden', 'true');        
    }
    setTimeout(() => { opts.el.focus(); }, 100);
});

$home_accordion.on('home-saved-jobs-notifications.trigger', function (event, opts) {
    event.preventDefault();

    if (opts.state == "true") {
        opts.target.attr('aria-hidden', 'false');
    } else {
        opts.target.attr('aria-hidden', 'true');
    }
    setTimeout(() => { opts.el.focus(); }, 100);
});

var $fed_app = $('[data-object="landing-fed-app-process"]');

$fed_app.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="landing-fed-app-process"]'),
      behavior = $el.attr('data-behavior'),
      $target = $object.find('#' + $el.attr('aria-controls')),
      state = $target.attr('aria-hidden');

    event.preventDefault();

    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        if (action.match(/^landing-fed-app-process/)) {
            $el.trigger(action, { el: $el, object: $object, target: $target, state: state });
        }
    });
});

$fed_app.on('landing-fed-app-process.open', function (event, opts) {
    var $siblings;

    if (opts.state == "true") {
        // Close siblings
        $siblings = opts.object.find('[data-behavior="landing-fed-app-process.open"]');

        $siblings.each(function (idx, sibling) {
            var $sibling = $(sibling),
              $sibling_target = opts.object.find('#' + $sibling.attr('aria-controls'));

            $sibling.attr('aria-expanded', 'false');
            $sibling_target.attr('aria-hidden', 'true');
        });

        opts.el.attr('aria-expanded', 'true');
        opts.target.attr('aria-hidden', 'false');

        opts.target.slideDown(function () {
            $('html, body').animate({
                scrollTop: opts.el.offset().top
            });
        });
    } else {
        opts.target.slideUp(function () {
            opts.el.attr('aria-expanded', 'false');
            opts.target.attr('aria-hidden', 'true');
        });
    }
});

//Adding jquery functions for convience
(function ($) {
    var validClass = 'pswd_info_valid'; //css style to apply to valid item
    var invalidClass = 'pswd_info_invalid'; //css style to apply to invalid item
    $.fn.makeValid = function () {
        this.removeClass(invalidClass).addClass(validClass);
    };
    $.fn.makeInValid = function () {
        this.removeClass(validClass).addClass(invalidClass);
    };
})(jQuery);

//Adding delay function to limit amount of ajax calls on keypress
var delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();
var $contact = $('[data-object="profile-contact"]');

$contact.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="profile-contact"]'),
      behavior = $el.attr('data-behavior'),
      $target = $object.find($el.attr('data-target'));

    event.preventDefault();
    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        $el.trigger(action, { el: $el, object: $object, target: $target });
    });
});

$contact.on('profile-contact.save', function (event, opts) {
    opts.target
      .attr('aria-hidden', 'false')
      .fadeIn(300, function () {
          $('html, body').animate({
              scrollTop: opts.target.parent().offset().top - 25
          });
      });
});

var $profile_question = $('[data-object="profile-question"]');

$profile_question.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="profile-question"]'),
      behavior = $el.attr('data-behavior'),
      $target = $object.find('#' + $el.attr('aria-controls')),
      state = $target.attr('aria-hidden');

    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        $el.trigger(action, { el: $el, object: $object, target: $target, state: state });
    });
});

$profile_question.on('profile-question.answer', function (event, opts) {
    if (opts.state == "true") {
        opts.el.removeClass('is-active');
        opts.target
          .attr('aria-hidden', 'false')
          .addClass('is-active');
    }
});

var $refiners = $('[data-object="search-current-refiners"]');

$refiners.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="search-current-refiners"]'),
      behavior = $el.attr('data-behavior'),
      $target = $('.usajobs-search').find('#' + $el.attr('aria-controls'));

    event.preventDefault();
    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        $el.trigger(action, { el: $el, object: $object, target: $target });
    });
});

$refiners.on('search-current-refiners.remove', function (event, opts) {
    var $el = opts.el.parent(),
      $list = $el.parent();

    event.preventDefault();

    $el.fadeOut(300, function () {
        $el.remove();

        if ($list.children().length === 0) {
            $refiners.find('.usajobs-search-current__label').remove();
        }
    });
});

$refiners.on('search-current-refiners.remove-all', function (event, opts) {
    event.preventDefault();

    $refiners.fadeOut(300, function () {
        $refiners.remove();
    });
});

$refiners.on('search-current-refiners.update-location', function (event, opts) {
    event.preventDefault();

    // This function updates the text "Multiple" from
    // the location field in search inside the top level navigation
    // if there is only one location displayed.
});

var $email = $('[data-object="username"]');

$email.on('click', '[data-behavior]', function (event) {
    var $el = $(this),
      $object = $el.closest('[data-object="username"]'),
      behavior = $el.attr('data-behavior'),
      $target = $object.find($el.attr('data-target'));

    event.preventDefault();
    $el.blur(); // Removes focus

    // Each behavior attached to the element should be triggered
    $.each(behavior.split(' '), function (idx, action) {
        $el.trigger(action, { el: $el, object: $object, target: $target });
    });
});

$email.on('username.save', function (event, opts) {
    opts.target
      .attr('aria-hidden', 'false')
      .fadeIn(300, function () {
          $('html, body').animate({
              scrollTop: opts.target.parent().offset().top - 25
          });
      });
});
